import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useDevelopments = (fallback = []) => {
  const [developments, setDevelopments] = useState(fallback);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/developments`)
      .then((r) => { if (r.data.length) setDevelopments(r.data); })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return { developments, loaded };
};
